export default __webpack_public_path__ + "static/media/golang.e8577c90.png";